module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "design"
    }
  }, [_c('contentMenu'), _vm._v(" "), _c('designContent'), _vm._v(" "), _c('contentFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dc30f7a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Design.vue
// module id = 70
// module chunks = 0